import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { settingColumnsConfig } from "../config/Setting"; // Updated to 'settingColumnsConfig'
import { ConfirmPopup } from "../Confirmation";
import { useNavigate } from "react-router-dom"; 
import { getSettingWithFilter } from "../../../slices/thunks";

export const getSettingColumns = ({ onDeleteClick, onEditClick }) => {
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
 



  // Handle Edit Click
  const handleEditClick = (row) => {
    navigate("/settings/add-form", { state: { id: row.id } }); // Pass the row ID to the /addform page
  };

  return [
    // {
    //   name: <span className="font-weight-bold fs-13">{settingColumnsConfig.ID}</span>, // Updated to settingColumnsConfig
    //   selector: (row) => row.id,
    //   sortable: true,
    // },
    {
      name: <span className="font-weight-bold fs-13">{settingColumnsConfig.RULES}</span>, // Updated to settingColumnsConfig
      selector: (row) => row.rules,
      sortable: true,
      width: "70%",
    },
    
    {
      name: <span className="font-weight-bold fs-13">{settingColumnsConfig.ACTIONS}</span>, // Updated column name to "Actions"
      width: "30%",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2 justify-content-center">
          {/* Edit Button */}
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              handleEditClick(row); // Navigate and pass the ID to /addform
            }}
            className="fs-13 nav-link"
          >
            <i className="ri-edit-2-fill fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle"></i>
          </a>

          {/* Delete Button */}
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setConfirmOpenForId(row.id);
            }}
            className="fs-13 nav-link"s
          >
           <i
  className="ri-delete-bin-7-fill fs-16 p-2 bg-soft-danger rounded-circle align-middle icon-red"
></i>
 </a>

          {/* Confirm Delete Popup */}
          {confirmOpenForId === row.id && (
            <ConfirmPopup
            
              message={settingColumnsConfig.messages} // Updated message from settingColumnsConfig
              setConfirmOpen={() => setConfirmOpenForId(null)}
              onConfirm={() => {
                onDeleteClick(row.id); // Removed event since it's not needed here
                setConfirmOpenForId(null);
              }}
              style={{ left: "0px", top: "10px", backgroundColor: "lightblue" }} // Apply the negative right margin here
            />
          )}
        </div>
      ),
    },
  ];
};
